const initialState = {};
const state = {
  ...initialState,
  result: {
    data: [],
    tableConfig: {
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 15,
      },
      columns: [],
    },
  },
  filter: {},
  currentFilter: {
    dateFrom: '',
    dateTo: '',
    applicationId: null,
    messageLocationCode: null,
    roleId: null,
  },
  catalog: {
    application: [],
    location: [],
    rol: [],
  },
};

export default state;
